export { default as Variations } from "./variations";

export const Mode = {
  Dialog: "Dialog",
  Embedded: "Embedded",
};

export const FacebookPixel = "Facebook Pixel";
